module.exports = __webpack_public_path__ + "static/media/settings_wine.300f93e4.svg";